import { Park } from '@unleashed/models/park';

export interface BookingSession {
  park?: Park | null;
  subtotal?: number;
  bookingId?: string;
  step?: string;
}
